import React from "react";
import Matrix from "../Matrix/Matrix";
import Glass from "./Glass/Glass";
import { useAuth } from '../global_state_components/AuthProvider';

function MatrixWithGlassOnTop(){
  const { isAuthenticated } = useAuth();

  if (isAuthenticated==='loading'){
    return <div>Loading</div>
  }

  //<Navigate to="/matrix"/>

  return(
    (isAuthenticated === 'authenticated')?(

      <Matrix/>
  
      ):(
  
      <div>
        <Matrix/>
        <Glass/>
      </div>
  
    )
  )

}

export default MatrixWithGlassOnTop;